import { IGameCustomTemplate } from 'js/hooks/games/types';

export const getCustomTemplate = ({ lang = '', customTemplates }: {
    lang?: string;
    customTemplates: IGameCustomTemplate[];
}) => {
    const defaultTemplate = customTemplates.find((template) => template.lang === '');
    const currentTemplate = customTemplates.find((template) => template.lang === lang);

    return currentTemplate?.value || defaultTemplate?.value || '';
};
